import React, { Component, Fragment } from 'react';
import {withRouter, Link} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import { numberFormat } from '../../common';
import Message from '../message';

@withRouter
@inject('totoStore', 'dictStore')
@observer
export default class Previous extends Component{

  componentDidMount() {
    this.props.totoStore.Previous.init();
  }

  componentWillUnmount() {
    this.props.totoStore.Previous.dispose();
  }

  render() {
    const {isLoading, result, Previous} = this.props.totoStore;
    const {getLang} = this.props.dictStore;
    return(
      !isLoading ? 
        <div className="toto-index-loading">
          <LoadingSpinner />
        </div> :
      <Fragment>
        {Previous.data ? <TotoPrevious /> : <Message text={result.text}/>}
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore')
@observer
class TotoPrevious extends Component { 

  selectCurrency = (e) => {
    this.props.totoStore.selectCurrency(e.target.value)
  }

  selectYear = (v) => {
    this.props.totoStore.Previous.selectYear(v);
  }

  selectMonth = (v) => {
    this.props.totoStore.Previous.selectMonth(v);
  }

	render() {

    const {getLang} = this.props.dictStore;
    const {currency, currencyId, current} = this.props.totoStore;
    const {data, selected, draw} = this.props.totoStore.Previous;

		return(
			<div className="toto-previous">
        <div className="clearfix">
          <div className="fl_r">
            <label htmlFor="toto-currency">{getLang('SHOW_IN_CURRENCY')} </label>
            <select className="toto-index-currency" onChange={this.selectCurrency}>
              {Object.keys(data.currency).map(id => 
                <option key={id} value={data.currency[id].id} selected={data.currency[id].id == currencyId}>{data.currency[id].full_name}</option>
              )}
            </select>
          </div>
          <nav>
            <ul className="toto-previous-year-list clearfix">
              {Object.keys(data.date_menu).reverse().map(item => 
                <li key={item} className={`toto-previous-year fl_l${ selected.year == item ? ' toto-previous-year-selected' : ''}`}>
                  <a className="toto-previous-year-a" href="#" onClick={() => this.selectYear(item)}>{item}</a>
                </li>  
              )}
            </ul>
            <ul className="toto-previous-month-list clearfix">
              {Object.keys(data.date_menu[selected.year]).map(item => 
                <li key={item} className={`toto-previous-month fl_l${ item == selected.month ? ' toto-previous-month-selected' : ''}`} >
                  <a className="toto-previous-month-a" href="#" onClick={() => this.selectMonth(item)}>{getLang(`MONTH${item}`)}</a>
                </li>
              )}
            </ul>
          </nav>
        </div>
        <div className="toto-previous-table-cont">
          <table className="toto-table">
              <thead>
                <tr>
                  <th>№</th>
                  <th>{getLang('START_DATE')}</th>
                  <th>{getLang('JACKPOT')}</th>
                  <th>{getLang('POOL')}</th>
                  <th>{getLang('BETS')}</th>
                  <th>{getLang('OPTIONS')}</th>
                  <th>{getLang('HAS_WON')}</th>
                  <th>{getLang('MAX_GUESSED')}</th>
                  <th>{getLang('NOTE')}</th>
                </tr>
              </thead>
              <tbody className="toto-previous-no-draws">
                <Rows />
              </tbody>
          </table>
        </div>
      </div>
		)
	}
}


@inject('totoStore', 'dictStore')
@observer
class Rows extends Component {
  render() {

    const {getLang} = this.props.dictStore;
    const {currencyId, current} = this.props.totoStore;
    const {draw, data} = this.props.totoStore.Previous;

    return(
      <Fragment>
        {!draw ? 
          <tr>
            <td colSpan="9">
              {getLang('NO_DRAWS_FOR_CURRENT_PERIOD')}
            </td>
          </tr>
          :
          draw.map(item => {
            const el = data.draws[item];
            return(
              <tr>
                <td className="toto-previous-table-id"><Link to={`/toto/result/${el.id}`}>{el.number}</Link></td>
                <td className="toto-table-date">{el.date}</td>
                <td className="toto-previous-table-jackpot">{numberFormat(el.jackpot[currencyId], 2, ',', ' ')} {current.name}</td>
                <td className="toto-previous-table-pool">{numberFormat(el.pool[currencyId], 2, ',', ' ')} {current.name}</td>
                <td className="toto-previous-table-count-set"><Link to={`/toto/cardsall/${el.id}`}>{el.cards_count.set}</Link></td>
                <td className="toto-previous-table-option-count">{el.bets_count.total}</td>
                <td className="toto-previous-table-count-win">{el.cards_count.win ? <Link to={`/toto/cards/${el.id}`}>{el.cards_count.win}</Link> : el.cards_count.win}</td>
                <td className="toto-previous-table-option-guessed">{el.bets_count.guessed ? <Link to={`/toto/cards/${el.id}/${el.bets_count.guessed}`}>{el.bets_count.guessed}</Link> : el.bets_count.guessed}</td>
                <td className="toto-previous-table-table-comment">{el.comment_id > 0 ? getLang('TOTO_PREVIOUS_COMMENT_' + el.comment_id) : ' '}</td>
              </tr>
            )
          })
        }
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/toto/previous.jsx